import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { saveStatesByBodyshop, saveStatesUser } from './stateActions';
import { GetStatesByBodyshop, GetStatesUser } from './stateTypes';

// Api's
import { stateApi } from '../../api';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

export function* getStatesUserSaga(action: GetStatesUser) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      stateApi.getDomain,
      action.payload.request
    );
    if (response.data.result) {
      yield put(saveStatesUser(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveStatesUser(null, true, resultError.messagesDataError));
    }
  }
}

export function* getStatesByBodyshopSaga(action: GetStatesByBodyshop) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      stateApi.getDomainByBodyshop,
      action.payload.request
    );
    if (response.data.result) {
      yield put(saveStatesByBodyshop(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);
      yield put(saveStatesByBodyshop(null, true, resultError.messagesDataError));
    }
  }
}

